const HEX_COLOR_PATTERN = /^#([0-9a-f]{3}){1,2}$/i;

/**
 * Parses the custom-colors cookie value, recovering colours from a legacy
 * bare/comma-joined hex format if it isn't a JSON array.
 */
export function getStoredCustomColors(storedCustomColors: string): string[] {
  try {
    const parsed = JSON.parse(storedCustomColors);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return storedCustomColors
      .split(",")
      .map((color) => color.trim())
      .filter((color) => HEX_COLOR_PATTERN.test(color));
  }
}
